import { useReminderDeleteMutation } from "web_myplann/Api/Reminders/useReminderDeleteMutation";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import type { Reminder } from "web_myplann/Reminders/Types/ReminderTypes";
import { MyPlannDialog } from "web_myplann/Shared/Components/MyPlannDialog";

type Props = {
	reminder: Reminder;
	open: boolean;
	onClose: () => void;
};

export const DeleteReminderDialog = ({ reminder, open, onClose }: Props) => {
	const { t } = useResource();
	const { mutate: deleteReminder } = useReminderDeleteMutation();

	const handleResult = (result: boolean) => {
		if (result) {
			deleteReminder(reminder.id, { onSuccess: onClose });
			return;
		}
		onClose();
	};

	return (
		<MyPlannDialog
			open={open}
			handleResult={handleResult}
			modalTitle={t(Resources.Reminders.Delete.title)}
			confirmButtonText={t(Resources.Reminders.Delete.confirm)}
			cancelButtonText={t(Resources.Reminders.Delete.cancel)}
		/>
	);
};
